import { useEffect, useState } from "react";
import { instance } from "../../store/utils";
import { useLogin } from "../../hooks/useLogin";
import "./login.css";

import { Input } from "antd";

import { loginUser } from "../../store/user/actions";
import { useDispatch } from 'react-redux';

import { useLoginSso } from "../../hooks/useLoginSso";

const Login = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState(false);
  const [ssoModule, setSsoModule] = useState(false);
  //grab what we want from useLogin hook
  const { isLoading } = useLogin();

  useEffect(() => {

    instance
      .get("/api/sso/ssoEnabled", {
        headers: {
          "Cache-Control": "no-cache"
        }
      })
      .then(response => {
        if (response.status === 200) {
          setSsoModule("true");
        } else {
          setSsoModule("false");
        }
      })
      .catch((error) => {
        console.debug("ssoEnabled ",error?.response?.data);
      });

  }, []);




  const handleSubmit = async e => {
    e.preventDefault();

    dispatch(loginUser({email, password,
      callback: check => {
        setLoginError(check)
      }}));
  };

  return (
    <form className="login" id="login-page" onSubmit={handleSubmit}>
      <header id="login-header">
        <h1 id="login-title">Login</h1>
      </header>
      <div id="login-content">
        <div className="form-group" id="login-page-form">
          <label id="labelEmail">Email</label>
          <Input
            id="inputEmail"
            className={loginError ? "error" : ""}
            type="email"
            onChange={e => setEmail(e.target.value)}
            value={email}
            autoComplete="new-password"
          />
          <span id="error-message">Invalid username or password.</span>
        </div>

        <div className="form-group" id="login-page-form-2">
          <label id="labelPassword">Password</label>
          <Input
            id="inputPassword"
            className={loginError ? "error" : ""}
            type="password"
            onChange={e => setPassword(e.target.value)}
            value={password}
            autoComplete="new-password"
          />
        </div>

        <div id="forgotPassword">
          <a href="/regcom/forgot-password">Forgot my password</a>
        </div>
        <div id="remember-me-group">
          <label id="labelRememberMe">Remember me</label>
          <input type="checkbox" id="rememberMe" />
        </div>

        <button className="cursor-pointer" id="login-page-button" disabled={isLoading} type={"submit"}>
          Login
        </button>

        {/* <div id="signup-link">
          <span>
            No Account? <a href="/regcom/signup">Sign Up</a>
          </span>
        </div> */}
      {ssoModule &&(
         <div id="sso-link" className="sso-link">
         <span >
           <button onClick={useLoginSso} className="cursor-pointer" type={"button"}>Sign in with Microsoft</button>
         </span>
         </div>
      )
      } 
      </div>
      {/* {error && <div className="error">{error}</div>} */}
    </form>
  );
};

export default Login;
